import Vue from 'vue'
import VueGtag from "vue-gtag"
import VueCookies from 'vue-cookies'

import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueMeta from 'vue-meta'
// import MarkdownIt from 'markdown-it'
import VueSocialSharing from 'vue-social-sharing'

import '@/assets/style.scss'

Vue.use(VueSocialSharing);
Vue.use(VueMeta)

// Vue.use(MarkdownIt)

Vue.config.productionTip = false

Vue.use(VueCookies)

// set default config
Vue.$cookies.config('7d')

Vue.use(VueGtag, {
  config: { id: 'UA-123492035-1' },
  includes: [
    { id: 'AW-785651670' },
  ]
}, router)

// Vue.use(VueGtag, {
//   config: { id: 'AW-785651670' }
// }, router)


import VueGtm from 'vue-gtm';
// import VueRouter from 'vue-router';
// const router = new VueRouter({ routes, mode, linkActiveClass });

Vue.use(VueGtm, {
  id: 'GTM-NJW73HV', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
  // queryParams: { // Add url query string when load gtm.js with GTM ID (optional)
  //   gtm_auth:'AB7cDEf3GHIjkl-MnOP8qr',
  //   gtm_preview:'env-4',
  //   gtm_cookies_win:'x'
  // },
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  // debug: true, // Whether or not display console logs debugs (optional)
  // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
